import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { useUserInfoDialogFooter } from "@/hooks/user-info-form/useUserInfoDialogFooter";

interface UserInfoDialogFooterProps {
  onOpenChange: (open: boolean) => void;
}

export function UserInfoDialogFooter({ onOpenChange }: UserInfoDialogFooterProps) {
  const { t, handleSubmit, handleCancel, hasErrors } = useUserInfoDialogFooter();

  return (
    <DialogFooter className="gap-2">
      <Button variant="outline" onClick={() => handleCancel(onOpenChange)}>
        {t("dialogs.cancel")}
      </Button>
      <Button onClick={handleSubmit} disabled={hasErrors()}>{t("common.submit")}</Button>
    </DialogFooter>
  );
}
